import MeetingList from './admin/MeetingList';

export default function Home() {
  return (
    <MeetingList/>
  );
}